import React from 'react'

function Heading ({ children, text, level = '3', theme }) {
  let content = text
  if (children) {
    content = children
  }

  return (
    <>
      {level && level === '1' && (
        <h1 data-theme={theme} className='text-4xl text-border font-shell-heavy my-3'>
          {content}
        </h1>
      )}
      {level && level === '2' && (
        <h2 data-theme={theme} className='text-5xl text-border font-shell-heavy mb-3'>
          {content}
        </h2>
      )}
      {level && level === '3' && (
        <h3 data-theme={theme} className='text-2xl text-border font-shell-heavy my-3'>
          {content}
        </h3>
      )}
      {level && level === '4' && (
        <h4 data-theme={theme} className='text-xl text-border font-shell-heavy my-3'>
          {content}
        </h4>
      )}
      {level && level === '5' && (
        <h5 data-theme={theme} className='text-lg text-border font-shell-heavy my-3'>
          {content}
        </h5>
      )}
      {level && level === '6' && (
        <h6 data-theme={theme} className='text-base text-border font-shell-heavy my-3'>
          {content}
        </h6>
      )}
    </>
  )
}

export default Heading
